import { render, staticRenderFns } from "./account-invite-earn.vue?vue&type=template&id=55b4397a&"
import script from "./account-invite-earn.vue?vue&type=script&lang=js&"
export * from "./account-invite-earn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports